export const GAMES = {
  ruanica: {
    title: "Ruanica",
    image: "/games/ruanica/banner.png",
    content: [
      "A real-life Augmented Reality RPG that blurs the line between game and world. Explore your surroundings, fight the unknown, and write your own story.",
    ],
    cta: { label: "Learn more", href: "/ruanica" },
  },
  grimtile: {
    title: "Grimtile",
    image: "/games/grimtile/banner.png",
    imagePosition: "top",
    content: [
      "A bite-sized dungeon crawler built around one simple idea: fight, loot, survive. Reveal the door and push deeper, if you dare.",
    ],
    cta: { label: "Learn more", href: "/grimtile" },
  },
}
